import { init as initApm } from "@elastic/apm-rum"

const apm = initApm({
  serviceName: "admin-app",
  serverUrl: "https://apm.dr.boxisoft.ir",
  distributedTracingOrigins: [
    "https://prod-api-resource-boxit.boxisoft.ir",
    "https://oauth.boxit.ir",
    "https://prod-consignment-boxit.boxisoft.ir",
    "https://prod-api-boxit.boxisoft.ir",
    "https://prod-swcustomer-boxit.boxisoft.ir",
    "https://gateway.boxit.ir",
    "https://public-api.boxit.ir",
    "https://guid.boxit.ir",
  ],
})


export default apm
